import { apiRequest } from '../client'

export const externalRefsApi = {
  lookupBySku: (source: string, externalSku: string) =>
    apiRequest(
      `/api/v0/admin/products/external-refs/lookup?source=${encodeURIComponent(source)}&externalSku=${encodeURIComponent(externalSku)}`,
    ),
  listBySource: (source: string) =>
    apiRequest<{
      items: Array<{ sku: string; externalId?: number; externalSku?: string }>
    }>(
      `/api/v0/admin/products/external-refs?source=${encodeURIComponent(source)}`,
    ),
}
